import Box from '@mui/material/Box';
import { Trans } from "react-i18next";
import ProfileAvatar from "../../../components/ProfileAvatar";
import ProfileContext from './ProfileContext';

export default function () {

  return (
    <ProfileContext.Consumer>
      { context => {
        const userData = context.userData
        return (<Box className='profile-avatar-card'>
          <Box className='profile-avatar-title'>
            <Trans i18nKey={`screens.profile.sections.avatar.title`}></Trans>
          </Box>
          <ProfileAvatar diameter={125}></ProfileAvatar>
          <Box className='profile-avatar-name'>{`${userData.firstName} ${userData.lastName}`}</Box>
          <Box className='profile-avatar-role'>
            <Trans i18nKey={`models.functions.labels.${userData.role}`}></Trans>
          </Box>
        </Box>)
      }}
    </ProfileContext.Consumer>
  );
}